import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  className?: string;
  labelClassName?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, labelClassName, ...props }, ref) => {
    const hasError = !!error;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={props.id}
            className={cn(
              "block text-sm font-medium text-foreground mb-1",
              hasError && "text-red-700",
              labelClassName,
            )}
          >
            {label}
          </label>
        )}
        <input
          className={cn(
            "px-4 py-2.5 bg-[var(--input-bg)] border rounded-xl w-full transition duration-150 ease-in-out focus:outline-none focus:ring-2 placeholder:text-[var(--input-placeholder)] text-[var(--input-text)]",
            hasError
              ? "border-[var(--input-error)] focus:ring-[var(--input-error)]"
              : "border-[var(--input-border)] focus:ring-[var(--input-focus-ring)] focus:border-transparent",
            className,
          )}
          ref={ref}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";

export default Input;
